import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { RPA_DOMAINS } from "../../data/rpaDomains";
import { RPA_DOMAIN_CONTENT } from "../../data/rpaDomainManifest";

export default function RpaDomains() {
  const location = useLocation();
  const { domainSlug } = useParams();
  const shouldRedirect =
    !domainSlug && /\/rpa-use-cases\/?$/.test(location.pathname);

  const activeDomain =
    RPA_DOMAINS.find((d) => d.slug === domainSlug)?.id ||
    RPA_DOMAINS[0]?.id ||
    "financial-domain";

  const DomainContent = RPA_DOMAIN_CONTENT[activeDomain];
  const isLiveDomain = Boolean(DomainContent);

  if (shouldRedirect) {
    return <Navigate to="/rpa-use-cases/financial-domain" replace />;
  }

  return (
    <div style={{ background: isLiveDomain ? "#27baa7" : "#fff", minHeight: "60vh" }}>
      <main>
        {DomainContent ? (
          <DomainContent />
        ) : (
          <section style={{ maxWidth: 720, margin: "80px auto", padding: "0 35px", textAlign: "center" }}>
            <h1 style={{ fontFamily: "Exo, sans-serif", fontSize: 32, color: "#0b3475" }}>
              RPA use cases coming soon
            </h1>
          </section>
        )}
      </main>
    </div>
  );
}

